import React, { useEffect } from "react";
import { connect } from "react-redux";
import Traec from "traec";
import ProjectInviteItem from "./projectInviteItem";

function ProjectInvites({ items }) {
  // Fetch data when component mounts
  useEffect(() => {
    const requiredFetches = [new Traec.Fetch("project_invite_all", "list")];
    Traec.fetchRequired(requiredFetches);
  }, []);

  if (!items || !items.size) {
    return (
      <div className="list-group-item text-center py-4">
        <p className="text-muted mb-0">No project invitations</p>
      </div>
    );
  }

  const itemList = items.toList().map((item, i) => <ProjectInviteItem key={i} index={i} invite={item} />);

  return <div className="list-group list-group-flush">{itemList}</div>;
}

const mapStateToProps = (state, ownProps) => ({
  items: state
    .getInPath("entities.projectInvites.byId")
    ?.filter((i) => i?.getInPath("project_discipline.project.name")),
  isAuthenticated: state.getInPath("auth.isAuthenticated"),
});

export default connect(mapStateToProps)(ProjectInvites);
